module.exports = __webpack_public_path__ + "img/ia-01-4.b139e62a.jpg";